import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { createContext, useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingScreen from "../components/layout/Loading/Loading";
import { getDocumentoUnico } from "../firebase/CRUD";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const navigate = useNavigate();
    const [usuario, setUsuario] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const location = useLocation()
    const rota = location.pathname
    useEffect(() => {
        const auth = getAuth();
        let unsubscribeSnapshot = null; // Variável para guardar a função que desliga o Firestore

        const unsubscribeAuth = onAuthStateChanged(auth, (userFirebase) => {
            if (userFirebase) {
                // O Firebase reconhece que há um login ativo
                const docRef = doc(db, "usuarios", userFirebase.uid);
                
                // onSnapshot retorna uma função para desligar a escuta
                unsubscribeSnapshot = onSnapshot(docRef, (docSnap) => {
                    if (docSnap.exists()) {
                        const dadosFirestore = docSnap.data();
                        if(dadosFirestore.perfil === 'professor'){
                            getDocumentoUnico('professores',dadosFirestore.idProfessorDoc,(e)=>{
                                dadosFirestore.turma = e.turma
                                setUsuario({
                            uid: userFirebase.uid,
                            email: userFirebase.email,
                            ...dadosFirestore
                        });
                            },dadosFirestore.idEscola)
                        } else
                        setUsuario({
                            uid: userFirebase.uid,
                            email: userFirebase.email,
                            ...dadosFirestore
                        });
                    } else {
                        // console.error("Autenticado, mas sem documento na coleção 'usuarios'.");
                        setUsuario({uid: userFirebase.uid, email: userFirebase.email, novoUsuario: true});
                        if(rota !== '/cadastro')
                        navigate('/login');
                    }
                    
                    // Só encerra o carregamento DEPOIS de o Firestore responder
                    setCarregando(false); 
                    
                }, (error) => {
                    // Tratamento caso a leitura falhe (ex: regras de segurança)
                    console.error("Erro ao ler dados em tempo real:", error);
                    if(error.code === 'permission-denied'){
                        console.warn("Usuario autenticado, mas sem acesso ao documento de perfil")

                        if(rota === '/cadastro' || rota === '/perfil'){
                            setUsuario({uid:userFirebase.uid,email:userFirebase.email})
                        }else{
                            setUsuario(null);
                            navigate('/login')
                        }
                    } else {
                        setUsuario(null);
                        navigate('/login');
                    }
                    setCarregando(false);
                });
            } else {
                // Utilizador não está logado ou fez logout
                setUsuario(null);
                setCarregando(false);
                if(rota !== '/cadastro')
                navigate('/login');
                
                // Se ele tinha um snapshot ativo da sessão anterior, desligamos aqui
                if (unsubscribeSnapshot) {
                    unsubscribeSnapshot();
                }
            }
        });

        // Cleanup: O que acontece se o próprio AuthProvider for destruído da tela
        return () => {
            unsubscribeAuth(); // Desliga o listener do Auth
            if (unsubscribeSnapshot) {
                unsubscribeSnapshot(); // Desliga o listener do Firestore
            }
        };
    }, [navigate]); // navigate deve constar nas dependências do useEffect

    return (
        <AuthContext.Provider value={{ usuario, carregando }}>
            {carregando ? (
                <LoadingScreen/>
            ) : (
                children
            )}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(AuthContext);
};